import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import styles from './Tooltip.module.scss.js';

var TooltipFooter = function (props) {
    var classNameFooter = classNames(styles.footer, styles[props.mouseIcon], props.className);
    return jsx("div", { className: classNameFooter, children: props.children });
};

export { TooltipFooter as default };
//# sourceMappingURL=TooltipFooter.js.map
